import React from 'react';

const Appointment = () => {
    return (
        <div>
            This is appointment
        </div>
    );
};

export default Appointment;